import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  &&& {
    width: 100%;
    .MuiFormControl-root {
      overflow: inherit;
    }

    .MuiInputBase-root {
      border-radius: 3px !important;
      height: 40px !important;
      padding-top: 5px !important;
      padding-left: 0px !important;
    }

    .MuiInputBase-input {
      padding: 6px 10px 4px !important;
    }

    .MuiInputLabel-outlined {
      transform: translate(14px, 14px) scale(1);
    }

    .MuiInputLabel-outlined.MuiInputLabel-shrink {
      transform: translate(14px, -6px) scale(0.75);
    }
  }
`;

export const RowPart = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 100px 1fr 50px;
  justify-content: flex-start;
  align-items: center;
  gap: 0.4rem;
  padding: 0.2rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.grayDark};
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${({ theme }) => theme.grayLight};
  }
`;

export const AreaButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin: 1rem 0 0;
`;

export const SkeletonRowPart = styled(RowPart)`
  margin: 0.4rem 0;
`;

export const ContainerAutoFill = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  padding: 5px 10px;
  display: grid;
  grid-template-columns: 0fr 2fr repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 0px;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;

export const AutofillLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const ContainnerModalConfirmation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  text-align: center;
  padding-top: 1rem;
  font-weight: 600;


  .list {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;

    width: fit-content;
    margin: 0 auto;

    text-align: left;
  }

  p {
    margin: 0;
    white-space: nowrap;
  }
`;
